import { render } from "./ResearchItsGalleryComp.vue?vue&type=template&id=618db75e&scoped=true"
import script from "./ResearchItsGalleryComp.vue?vue&type=script&lang=js"
export * from "./ResearchItsGalleryComp.vue?vue&type=script&lang=js"

import "./ResearchItsGalleryComp.vue?vue&type=style&index=0&id=618db75e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618db75e"]])

export default __exports__